<template>
  <div
    :class="[
      'VisualButtonHorizontal',
      {
        isActive: isActive,
        fitWidth: variant.width === 'fit',
        disabled: variant.type === 'disabled',
        focus: variant.focus
      }
    ]"
    :style="{ color: variant.color }"
    @click="_onClickButton($event)"
  >
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      imgDetail: false,
    };
  },
  props: {
    text: String,
    isActive: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: Object,
      default: () => ({ color: "black" }),
    },
  },
  created () {},
  components: {},
  methods: {
    _onClickButton ($event) {
      this.$emit("click", $event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

$--focused-border: 2.5px solid $--color-primary;

.VisualButtonHorizontal {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  min-width: 13vw;
  padding: 0 7px;
  border: 1.2px solid $--border-color-base;
  font-size: 18px;
  font-weight: bold;
  border-radius: 1px;
  white-space: nowrap;
  display: inline-flex;
}

.fitWidth {
  min-width: auto;
}

.isActive {
  background: $background-blue-lighter;
  border: $--focused-border;
}

.disabled {
  color: $text-extra-light; // #dcdcdc;
}

.focus {
  border: $--focused-border;
}
</style>
